import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ListProps {
    children: ReactNode;
    className?: string;
}

export function List({ children, className }: ListProps) {
    return (
        <div className={cn('flex flex-col gap-8', className)}>{children}</div>
    );
}
